import { FormattedMessage } from 'react-intl';
import TabularPage from '../components/tabs/TabularPage';
import { FUEL_EMISSIONS_ROUTES } from 'constants/routes';

const routes = [
    {
        name: <FormattedMessage id="fuels_and_emissions_blend_definitions" />,
        relativePath: FUEL_EMISSIONS_ROUTES.PSBLENDS,
    },
    {
        name: <FormattedMessage id="fuels_and_emissions_rates" />,
        relativePath: FUEL_EMISSIONS_ROUTES.PSFUELEMISSIONRATES,
    },
];

const FuelsAndEmissionsPage = () => {
    return <TabularPage isAutoForm routes={routes} />;
};

export default FuelsAndEmissionsPage;
